/* Custom JS for SUGATA project */
/* Overriding/Extending Prestige theme functionality */
console.log('SUGATA custom.js loaded');

document.addEventListener('DOMContentLoaded', () => {
    initProductCardSliders();
});

function initProductCardSliders() {
    const sliders = document.querySelectorAll('[data-product-card-slider]');

    sliders.forEach(slider => {
        const track = slider.querySelector('.product-card__slider-track');
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false;

        track.addEventListener('mousedown', (e) => {
            isDown = true;
            track.style.cursor = 'grabbing';
            startX = e.pageX - track.offsetLeft;
            scrollLeft = track.scrollLeft;
            isDragging = false;
        });

        track.addEventListener('mouseleave', () => {
            isDown = false;
            track.style.cursor = 'grab';
        });

        track.addEventListener('mouseup', (e) => {
            isDown = false;
            track.style.cursor = 'grab';

            // Snap to nearest slide on release if we were dragging
            if (isDragging) {
                // Determine direction and snap? 
                // CSS scroll-snap takes care of it usually, 
                // but if we disabled snap during drag (via CSS active state),
                // it should re-enable and snap automatically after mouseup.
                // However, standard scroll-snap might not trigger momentum scrolling if we set scrollLeft manually per frame.
                // Let's rely on CSS re-enabling snap.
            }

            setTimeout(() => {
                isDragging = false;
            }, 50);
        });

        track.addEventListener('mousemove', (e) => {
            if (!isDown) return;

            e.preventDefault(); // Prevent text selection etc
            const x = e.pageX - track.offsetLeft;
            const walk = (x - startX) * 2; // Scroll-fast

            if (Math.abs(walk) > 5) {
                isDragging = true;
            }

            track.scrollLeft = scrollLeft - walk;
        });

        // Prevent link click if dragged
        const links = track.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', (e) => {
                if (isDragging) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            // Also prevent native drag of the link/image
            link.addEventListener('dragstart', (e) => e.preventDefault());
        });
    });
}
